import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { number } = proptypes;
import ListWrapper from './list/ListWrapper';

const GiftCardsList = ({ jsonType }) => {
  useEffect(() => {
    const jsonListType = jsonType || 3;
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('gift-cards-list.ready', jsonListType);
  }, []);

  return (
    <div className="grid" data-component="GiftCardsList" data-testid="GiftCardsList">
      <ListWrapper jsonType={jsonType} />
    </div>
  );
};

GiftCardsList.propTypes = {
  jsonType: number
};
GiftCardsList.defaultProps = {
  jsonType: 3
};

GiftCardsList.displayName = 'GiftCardsList';

export { GiftCardsList };
